import { gql } from '@apollo/client';

export const GET_SEASON_COMPETITION_TEAM_ROSTER = gql`
  query GetSeasonCompetitionTeamRoster($seasonCompetitionTeamId: ID!) {
    getSeasonCompetitionTeamRoster(seasonCompetitionTeamId: $seasonCompetitionTeamId) {
      id
      seasonCompetition {
        active
        season {
          displayName
        }
        competition {
          displayName
        }
      }
      team {
        id
        nameShow
        shortName
        fullName
        shield
        shieldBig
        shieldPng
      }
      players {
        id
        nick
        name
        lastName
        role
        marketValue
        image
        totalScore
        lastWeekScore
        lastWeekNumber
        team {
          id
          nameShow
          shield
          shieldPng
        }
      }
    }
  }
`;
